// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__BdaUe","image":"recipe_image__BtdIE","footer":"recipe_footer__368Kx","calories":"recipe_calories__24PXH"};